<template>
<div class="content-lists">
    <h3 v-if="!!list.title" class="mb-5" :class="list.textColor" v-html="list.title" />

    <ul>
        <li 
          v-for="(item, i) in listItems" 
          :key="`${ list.name }-list-item-${ i }`"
          v-html="`${ item }${ eol( i ) }`"
          :class="list.textColor"
        />
    </ul>
</div>
</template>

<script>
const H = require('js-to-html').html

export default {
  name: 'ContentLists',
  props: [
    'list',
  ],
  computed: {
    listItems() {
      let items = []

      this.list.items.forEach( item => {
        if( typeof item !== 'string' ) {
          item = H[ item.tag ]( _.omit( item, [ 'text', 'tag'] ), item.text ).toHtmlText()
        }
        items.push( item )
      })
      
      return items
    },
  },
  methods: {
    eol( i ) {
      return !!this.list.noEol ? '' : i === this.list.items.length - 1 ? '.' : ' ;'
    },
  },
}
</script>